import { CardController } from "./card/CardController";
import { DragController } from "./card/DragController";
import { GyroController } from "./card/GyroController";
import { CardWarp } from "./transitions/CardWarp";
import { Router } from "./pages/Router";
import { renderAbout } from "./pages/AboutView";
import { renderLink } from "./pages/LinkView";
import { bindBottomNav } from "./ui/BottomNav";
import { bindThemeToggle } from "./ui/ThemeToggle";

function $<T extends Element>(selector: string): T {
  const el = document.querySelector<T>(selector);
  if (!el) throw new Error(`Missing required element: ${selector}`);
  return el;
}

function $$<T extends Element>(selector: string): T[] {
  return Array.from(document.querySelectorAll<T>(selector));
}

function boot(): void {
  const root = $<HTMLElement>("[data-card-3d]");
  const pivot = $<HTMLElement>("[data-card-pivot]");
  const gyroLayer = $<HTMLElement>("[data-card-gyro]");
  const warp = $<HTMLElement>("[data-card-warp]");
  const overlay = $<HTMLElement>("#page-overlay");
  const navButtons = $$<HTMLButtonElement>(".bottom-nav .nav-btn");
  const themeBtn = $<HTMLButtonElement>("[data-theme-toggle]");

  const card = new CardController({ root, pivot });
  const drag = new DragController(card);
  new GyroController(gyroLayer);

  const cardWarp = new CardWarp({
    card,
    dragController: drag,
    overlay,
    warpEl: warp,
  });

  const router = new Router({
    cardWarp,
    overlay,
    navButtons,
    views: {
      about: renderAbout,
      link: renderLink,
    },
  });
  router.start();

  bindBottomNav(navButtons, router);
  bindThemeToggle(themeBtn);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", boot, { once: true });
} else {
  boot();
}
